/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerConsequences.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Consequences
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, January 21, 2019 - 12:43:41 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    CONSEQUENCE_LIST_CONTAINER_LOADED,
    CONSEQUENCE_LIST_CONTAINER_UNLOADED,
    CONSEQUENCE_LIST_TABLE_LOADED,
    CONSEQUENCE_LIST_TABLE_UNLOADED,

    CONSEQUENCE_SELECT_ROW,
    CONSEQUENCE_ADD,
    CONSEQUENCE_EDIT,
    CONSEQUENCE_DELETE,
    CONSEQUENCE_OPEN_WARNING,
    CONSEQUENCE_CLOSE_WARNING,

    CONSEQUENCE_EDIT_CONTAINER_LOADED,
    CONSEQUENCE_EDIT_CONTAINER_UNLOADED,
    CONSEQUENCE_EDIT_FORM_LOADED,
    CONSEQUENCE_EDIT_FORM_UNLOADED,
    CONSEQUENCE_EDIT_DATA_LOAD,
    CONSEQUENCE_EDIT_CONTAINER_SUBMIT,
    CONSEQUENCE_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeConsequences';

const defaultState = {
    refreshList: false,
    danger: false,
    consequenceid: 0,
    score: '',
    health: '',
    production: '',
    environment: '',
    color: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case CONSEQUENCE_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                consequences: action.payload[0] ? action.payload[0].records : null
            }
        case CONSEQUENCE_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case CONSEQUENCE_SELECT_ROW:
            return {
                ...state,
                consequenceid: action.id
            }
        case CONSEQUENCE_ADD:
            return {
                ...state
            }
        case CONSEQUENCE_EDIT:
            return {
                ...state,
                consequenceid: action.id
            }
        case CONSEQUENCE_DELETE:
            return {
                ...state,
                consequenceid: null
            }
        case CONSEQUENCE_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case CONSEQUENCE_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case CONSEQUENCE_EDIT_CONTAINER_LOADED:
        case CONSEQUENCE_EDIT_DATA_LOAD:
            return {
                ...state,
                consequenceid: action.payload[0] ? action.payload[0].consequenceid : 0,
                score: action.payload[0] ? action.payload[0].score : '',
                health: action.payload[0] ? action.payload[0].health : '',
                production: action.payload[0] ? action.payload[0].production : '',
                environment: action.payload[0] ? action.payload[0].environment : '',
                color: action.payload[0] ? action.payload[0].color : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case CONSEQUENCE_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case CONSEQUENCE_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case CONSEQUENCE_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case CONSEQUENCE_LIST_CONTAINER_UNLOADED:
        case CONSEQUENCE_LIST_TABLE_UNLOADED:
        case CONSEQUENCE_EDIT_CONTAINER_UNLOADED:
        case CONSEQUENCE_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerConsequences.js